import { render } from "./component-payer-adress.vue?vue&type=template&id=60000fca"
import script from "./component-payer-adress.vue?vue&type=script&setup=true&lang=js"
export * from "./component-payer-adress.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-payer-adress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60000fca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60000fca', __exports__)) {
    api.reload('60000fca', __exports__)
  }
  
  module.hot.accept("./component-payer-adress.vue?vue&type=template&id=60000fca", () => {
    api.rerender('60000fca', render)
  })

}


export default __exports__